"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminEmailContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.adminEmailContract = c.router({
    getHistoricEmailsByPlayerId: {
        method: 'GET',
        path: '/history/:playerId',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                emails: zod_1.z.array(models_1.ZEmailSelectPrivate),
                brevoContactUrl: zod_1.z.string().nullable(),
            }),
            400: c.type(),
        },
    },
    resendEmailsInBulk: {
        method: 'POST',
        path: '/resend-emails-in-bulk',
        body: zod_1.z.object({
            templateName: zod_1.z.custom(),
            drawId: zod_1.z.optional(zod_1.z.number()),
        }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
    },
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
});
//# sourceMappingURL=email.admin.contract.js.map